import { render, staticRenderFns } from "./AdimoButton.vue?vue&type=template&id=51a4e442&"
import script from "./AdimoButton.vue?vue&type=script&lang=js&"
export * from "./AdimoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports